import React from "react";
import { Button } from "../../components/Button";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { Loading } from "../../components/Loading";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import { Context } from "pages/Integrations";
import { EnvironmentsAPI } from "../../../providers/EnvironmentsAPI";
import styles from "@styles/integrations.module.scss";

import { OlgaEnvironmentsAPI } from "providers/OlgaEnvironmentsAPI";
import Toggle2 from "shared/components/Toggle2";
import { If } from "shared/components/control-statements";
import { Message } from "@components";

export class FalaeDrawer extends React.Component {
    state = {
        token: null,
        enabled: false,
        delivery_search_id: null,
        indoor_search_id: null,
    }

    async setAsyncState(data) {
        return new Promise((resolve) => this.setState(data, resolve));
    }

    async getHoldingOlgaConfigurations() {
        const response = await OlgaEnvironmentsAPI.getConfigurations();
        return response.getData({});
    }

    async getUnitOlgaConfigurations() {
        const selected_environment = EnvironmentStorage.getSelectedEnvironment();
        const configurations = await EnvironmentsAPI.getConfigurationsByAlias(selected_environment, 'olga', {});

        if (!configurations?.id) {
            return {};
        }

        const olga_configurations = await OlgaEnvironmentsAPI.getUnitConfigurations(configurations.id);
        return {
            unit_id: configurations.id,
            configurations: olga_configurations.getData({})
        };
    }

    async componentDidMount() {
        try {
            await this.setAsyncState({ loading: true });

            const holding_olga_configurations = await this.getHoldingOlgaConfigurations();
            const unit_olga_configurations = await this.getUnitOlgaConfigurations();

            this.setState({
                unit_id: unit_olga_configurations?.unit_id || null,
                token: unit_olga_configurations?.configurations?.falae?.token || "",
                enabled: holding_olga_configurations?.falae?.enabled || false,
                delivery_search_id: holding_olga_configurations?.falae?.delivery_search_id || "",
                indoor_search_id: holding_olga_configurations?.falae?.indoor_search_id || "",
            });

            await this.setAsyncState({ loading: false });
        } catch (err) {
            await this.setAsyncState({ loading: false });
        }
    }

    async onSave() {
        try {
            const { onSave } = this.props;
            const { unit_id, enabled, delivery_search_id, indoor_search_id } = this.state;

            await this.setAsyncState({ savingOptions: true });
            
            const holding_response = await OlgaEnvironmentsAPI.putConfigurations({
                falae: {
                    enabled: enabled,
                    delivery_search_id: delivery_search_id,
                    indoor_search_id: indoor_search_id,
                }
            });

            if (holding_response.getErrors([]).length > 0) {
                await this.setAsyncState({ savingOptions: false });
                return alert({ text: `Não foi possível a integração: ${holding_response.getErrors()[0]}` });
            }

            const unit_response = await OlgaEnvironmentsAPI.putUnitConfigurations(unit_id, {
                falae: {
                    token: this.state.token,
                }
            });

            if (unit_response.getErrors([]).length > 0) {
                await this.setAsyncState({ savingOptions: false });
                return alert({ text: `Não foi possível a integração: ${unit_response.getErrors()[0]}` });
            }            

            onSave && onSave();
        } catch (e) {
            await this.setAsyncState({ savingOptions: false });
        }
    }

    render() {
        const { visible, onClose } = this.props;
        const { token, enabled, delivery_search_id, indoor_search_id, savingOptions, loading, unit_id } = this.state;
        return (
            <Drawer
                visible={visible}
                onClose={onClose}
                closeInFade
                title={"Integração - Falae"}
                footer={
                    <If cond={unit_id}>
                        <Button
                            design="primary"
                            className="w-100"
                            onClick={this.onSave.bind(this)}
                            loading={savingOptions}
                            disabled={loading || savingOptions}
                        >
                            Salvar alterações
                        </Button>
                    </If>
                }
            >
                <Context />
                <If cond={!unit_id}>
                    <Message className="mt-20">
                        <p>
                            Essa unidade não está configurada para utilizar o Falaê.
                        </p>
                    </Message>
                </If>
                <If cond={unit_id}>
                    {loading ? (
                        <div className="d-flex justify-center align-center h-100">
                            <Loading fullScreen />
                        </div>
                    ) : (
                        <div className={styles.scrollContainer}>
                            <Input
                                design="two"
                                className="mb-20"
                                floatLabel="Token"
                                value={token}
                                onChange={(e) => this.setState({ token: e.target.value })}
                            />

                            <div className={styles.box}>
                                <div className="mb-20">
                                    <Toggle2
                                        title="Substituir avaliações Olga"
                                        checked={enabled}
                                        onChange={() => this.setState({ enabled: !enabled })}
                                    />
                                </div>

                                <If cond={enabled}>
                                    <Input
                                        design="two"
                                        className="mb-20"
                                        floatLabel="ID pesquisa delivery"
                                        value={delivery_search_id}
                                        onChange={(e) => this.setState({ delivery_search_id: e.target.value })}
                                    />
                                    <Input
                                        design="two"
                                        className="mb-20"
                                        floatLabel="ID pesquisa salão"
                                        value={indoor_search_id}
                                        onChange={(e) => this.setState({ indoor_search_id: e.target.value })}
                                    />
                                </If>
                            </div>
                        </div>
                    )}
                </If>
            </Drawer>
        );
    }
} 